var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFacebookWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.302,
    height: 18.302,
    viewBox: "0 0 18.302 18.302",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.064 18.3h6.714a.572.572 0 0 0 .572-.572l-.008-5.338a.572.572 0 0 0-.572-.572H7.054V9.914H8.77a.572.572 0 0 0 .572-.572V7.194a3.385 3.385 0 0 1 3.381-3.381H14.3v1.906h-.953a1.336 1.336 0 0 0-1.335 1.335v2.288a.572.572 0 0 0 .572.572H14.9l-.477 1.906h-1.84a.572.572 0 0 0-.572.572v5.338a.572.572 0 0 0 .572.572h3.655a2.066 2.066 0 0 0 2.062-2.064V2.064A2.066 2.066 0 0 0 16.238 0H2.064A2.066 2.066 0 0 0 0 2.064v14.175A2.066 2.066 0 0 0 2.064 18.3zm-.92-16.236a.921.921 0 0 1 .92-.92h14.175a.921.921 0 0 1 .92.92v14.175a.921.921 0 0 1-.92.92h-3.084v-4.2h1.716a.573.573 0 0 0 .555-.433l.763-3.05a.572.572 0 0 0-.555-.711h-2.479V7.054a.193.193 0 0 1 .191-.191h1.525a.572.572 0 0 0 .572-.572v-3.05a.572.572 0 0 0-.572-.572h-2.149A4.53 4.53 0 0 0 8.2 7.194V8.77H6.482a.572.572 0 0 0-.572.572v3.05a.572.572 0 0 0 .572.572H8.2v4.194H2.064a.921.921 0 0 1-.92-.92z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook_white.ccc9086f.svg";
export { ForwardRef as ReactComponent };